import { memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import ZpButton from 'components/zpButton';

import jobListClasses from '../list/index.module.css';
import classes from './InDemandJobsList.module.css';

const propTypes = {
  inDemandJobs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      jobsPageLink: PropTypes.string,
      locationsPageLink: PropTypes.string,
      resumePageLink: PropTypes.string,
    })
  ),
  title: PropTypes.string,
  standardSideBar: PropTypes.bool,
  TitleTagName: PropTypes.string,
  classNames: PropTypes.string,
};

const defaultProps = {
  inDemandJobs: [],
  TitleTagName: 'h3',
};

const InDemandJobsList = ({ inDemandJobs, title, className, standardSideBar, TitleTagName }) => {
  return (
    <div
      className={classNames(jobListClasses['job-list-container'], className, {
        [jobListClasses.standardSideBar]: standardSideBar,
      })}
    >
      <TitleTagName className={jobListClasses.subtitle}>
        {title || `Recent Job Searches`}
      </TitleTagName>
      <ul className={jobListClasses['job-list']}>
        {inDemandJobs.map((job) => (
          <li key={job.title} className={jobListClasses['job-list-item']}>
            <div className="list-link">
              {job.jobsPageLink && (
                <a href={job.jobsPageLink} className="list-link">
                  {' '}
                  {`${job.title} Jobs`}
                </a>
              )}
              {job.companyLink && (
                <a href={job.companyLink} className="list-link">
                  {' '}
                  {`${job.companyName} Jobs`}
                </a>
              )}
            </div>
            <div className={jobListClasses['job-list-item-data']}>
              {job.resumePageLink && (
                <label className="location">
                  <a href={job.resumePageLink} className={classes.jobListLink}>{`Resume`}</a>
                </label>
              )}
              {job.comboCityCompanyLink && (
                <label className="location">
                  <a
                    href={job.comboCityCompanyLink}
                    className={classes.jobListLink}
                  >{`Location`}</a>
                </label>
              )}
              {job.resumePageLink && job.locationsPageLink && <label className="dot-separator" />}
              {job.locationsPageLink && (
                <label className="location">
                  <a href={job.locationsPageLink} className={classes.jobListLink}>{`Location`}</a>
                </label>
              )}
              {(job.resumePageLink || job.locationsPageLink) &&
                (job.comboCityPageLink || job.comboTitleCompanyLink) && (
                  <label className="dot-separator" />
                )}
              {job.comboCityPageLink && (
                <label className="location">
                  <a href={job.comboCityPageLink} className={job.jobListLink}>
                    {job.city}
                  </a>
                </label>
              )}
              {job.comboTitleCompanyLink && (
                <label className="location">
                  <a
                    href={job.comboTitleCompanyLink}
                    className={job.jobListLink}
                  >{`${job.title} ${job.companyName} Jobs`}</a>
                </label>
              )}
            </div>
          </li>
        ))}
      </ul>
      <a href="/jobs/" className="mt-1">
        <ZpButton theme="primary" size="big" isFullWidth>
          Explore All Jobs
        </ZpButton>
      </a>
    </div>
  );
};

InDemandJobsList.propTypes = propTypes;
InDemandJobsList.defaultProps = defaultProps;

export default memo(InDemandJobsList);
